import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 VIEW (lo que recibes del backend)
 */
export interface CapacitacionAsistenciaView {
    id?: number;
    capacitacion_id?: number;
    capacitacion_programacion_id?: number;
    actividad_id?: number | null;
    cedula?: number;
    nombre?: string | null;
    asistio?: number;
    aprobado?: number;
    calificacion?: number | null;
    observaciones?: string | null;
    estado?: number;
    fechaCreacion?: Date;
    fechaModificacion?: Date | null;
}

@Injectable({
  providedIn: "root",
})
export class CapacitacionesAsistentesService {
  private apiUrl = `${environment.apiUrl}/api/capacitacion-asistencia`;

  constructor(private http: HttpClient) {}

  getAllCapacitacionAsistencia(): Observable<CapacitacionAsistenciaView[]> {
    return this.http
      .get<CapacitacionAsistenciaView[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getCapacitacionAsistenciaById(id: string | number): Observable<CapacitacionAsistenciaView> {
    return this.http
      .get<CapacitacionAsistenciaView>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getCapacitacionAsistenciaByCapacitacion(capacitacionId: string | number): Observable<CapacitacionAsistenciaView[]> {
    return this.http
      .get<CapacitacionAsistenciaView[]>(`${this.apiUrl}/capacitacion/${capacitacionId}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  createCapacitacion(payload: CapacitacionAsistenciaView): Observable<any> {
    return this.http
      .post<any>(this.apiUrl, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

   createCapacitacionPublica(payload: CapacitacionAsistenciaView, tenantId: number): Observable<any> {
    return this.http
      .post<any>(`${this.apiUrl}/public/${tenantId}`, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  updateCapacitacionAsistencia(
    id: string | number,
    payload: CapacitacionAsistenciaView,
  ): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}`, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  deleteCapacitacionAsistencia(id: string | number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  activarCapacitacionAsistencia(id: string | number): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/${id}/activar`,
        {},
        {
          withCredentials: true,
        },
      )
      .pipe(catchError((error) => throwError(() => error)));
  }

  inactivarCapacitacionAsistencia(id: string | number): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/${id}/inactivar`,
        {},
        {
          withCredentials: true,
        },
      )
      .pipe(catchError((error) => throwError(() => error)));
  }

  getCapacitacionAsistenciaByCedula(cedula: string): Observable<CapacitacionAsistenciaView[]> {
    return this.http
      .get<CapacitacionAsistenciaView[]>(`${this.apiUrl}/cedula/${cedula}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }
}